module.exports = __webpack_public_path__ + "img/saveWhite.9c00bfe5.svg";